import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import SideMenu from "../component/SideMenu";
import Topbar from "../component/Topbar";
import ProjectDetails from "../component/ProjectDetails";
import L from 'leaflet';

// Import Leaflet and Geoman CSS
import 'leaflet/dist/leaflet.css';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import '@geoman-io/leaflet-geoman-free';

// Fix for default marker icons
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

// Component to initialize Drawing Controls
const GeomanControls = ({ onAreaChange }) => {
  const map = useMap();

  useEffect(() => {
    if (!map.pm) return;

    map.pm.addControls({
      position: 'topleft',
      drawMarker: true,
      drawPolyline: true,
      drawRectangle: true,
      drawPolygon: true,
      drawCircle: true,
      editMode: true,
      removalMode: true,
    });

    const calculateTotalArea = () => {
      let total = 0;
      // Iterate through all layers on the map
      map.eachLayer((layer) => {
        // Check if it's a Geoman-drawn layer with area capability
        if (layer instanceof L.Polygon || layer instanceof L.Rectangle || layer instanceof L.Circle) {
            if (layer.getLatLngs) {
                // For Polygons/Rectangles
                total += L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
            } else if (layer.getRadius) {
                // For Circles: PI * r^2
                total += Math.PI * Math.pow(layer.getRadius(), 2);
            }
        }
      });
      onAreaChange(total);
    };

    // Listen for creation, editing, and removal
    map.on('pm:create', calculateTotalArea);
    map.on('pm:remove', calculateTotalArea);
    map.on('pm:edit', calculateTotalArea);

    return () => {
      map.off('pm:create', calculateTotalArea);
      map.off('pm:remove', calculateTotalArea);
      map.off('pm:edit', calculateTotalArea);
    };
  }, [map, onAreaChange]);

  return null;
};


const Home = () => {
  // const position = [42.3314, -83.0458]; 
const [map, setMap] = useState(null);
const [position, setPosition] = useState([42.3314, -83.0458]);
const [locationName, setLocationName] = useState("Detroit, MI");
  const [totalArea, setTotalArea] = useState(0);

// Function to move map to searched location
  const handleLocationSearch = (lat, lng, name) => {
    if (map) {
      const newPos = [lat, lng];
      setPosition(newPos);
      setLocationName(name || "Custom Location");
      map.flyTo(newPos, 17); // Smooth zoom to location
    }
  };


const userToken = localStorage.getItem('userToken');
// console.log("userToken", userToken);

  return (
    <div className="app-container">
      <Topbar  onLocationSelect={handleLocationSearch} />
      
      <div className="main-wrapper">
        <SideMenu />

        {/* Left Section: Map */}
        <div className="map-section">
          <MapContainer 
            center={position} 
            zoom={15} 
            scrollWheelZoom={true} 
            style={{ height: "100%", width: "100%" }}
            ref={setMap} // Set map instance
          >
            <TileLayer
              attribution='&copy; OpenStreetMap contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            
            {/* Initialize Drawing Toolbar */}
            <GeomanControls onAreaChange={setTotalArea} />
            <Marker position={position}>
              <Popup>{locationName}</Popup>
            </Marker>


          </MapContainer>
        </div>

        {/* Right Section: Details Panel */}
        <ProjectDetails 
            locationName={locationName} 
            setLocationName={setLocationName}
            coords={position} 
            area={totalArea} 
        />
      </div>
    </div>
  );
};

export default Home;